module.exports = __webpack_public_path__ + "img/syyxs.f722b27d.jpg";